import type {SerializedStyles} from '@emotion/react';

import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Text} from '@travel-frontend/core';

import {Name} from '@/modules/common/components/RegionSelect/components/Option/components/Name';

type Props = {
  reactSelectStyles: any;
  isFocused: boolean;
  isSelected: boolean;
  children: React.ReactNode;
  isDisabled: boolean;
  hasChild: boolean;
  groupLayout: boolean;
  indented: boolean;
};

const colorVariant = (
  // @ts-expect-error TS(7006)
  isSelected,
  // @ts-expect-error TS(7006)
  isDisabled,
  // @ts-expect-error TS(7006)
  isFocused,
  // @ts-expect-error TS(7006)
  theme
): null | undefined | SerializedStyles => {
  if (theme.isAccessibleTheme) {
    if (isSelected) {
      return css`
        color: ${theme.colors.interactionSecondary};
      `;
    }

    if (isFocused) {
      return css`
        color: ${theme.colors.contentInversePrimary};
      `;
    }
  }

  if (isSelected) {
    return css`
      color: ${theme.colors.interactionSecondary};
    `;
  }

  if (isDisabled) {
    return css`
      color: ${theme.colors.contentTertiary};
    `;
  }

  return css`
    color: ${theme.colors.contentPrimary};
  `;
};

const backgroundVariant = (
  // @ts-expect-error TS(7006)
  isSelected,
  // @ts-expect-error TS(7006)
  isFocused,
  // @ts-expect-error TS(7006)
  theme
): null | undefined | SerializedStyles => {
  if (theme.isAccessibleTheme) {
    if (isSelected) {
      return css`
        background: ${theme.colors.backgroundPrimary};
        border: 1px solid ${theme.colors.interactionSecondary};
      `;
    }

    if (isFocused) {
      return css`
        background: ${theme.colors.interactionSecondary};
      `;
    }
  }

  if (isSelected) {
    return css`
      background: ${theme.colors.backgroundStateSelected};
    `;
  }

  if (isFocused) {
    return css`
      background: ${theme.colors.backgroundStateHover};
    `;
  }

  return css`
    background: transparent;
  `;
};

// Controls font-weight across states, only for accessibility theme
const fontVariant = (
  // @ts-expect-error TS(7006)
  isSelected,
  // @ts-expect-error TS(7006)
  isFocused,
  // @ts-expect-error TS(7006)
  theme
): null | undefined | SerializedStyles => {
  if (!theme.isAccessibleTheme) {
    return null;
  }

  if (isSelected && isFocused) {
    return css`
      font-weight: 400;
    `;
  }

  if (isFocused) {
    return css`
      font-weight: 700;
    `;
  }

  if (isSelected) {
    return css`
      font-weight: 400;
    `;
  }

  return css`
    font-weight: 400;
  `;
};

export const Container = styled.div<Props>(
  ({
    theme,
    reactSelectStyles,
    groupLayout,
    indented,
    isFocused,
    isSelected,
    isDisabled,
  }) => css`
    ${css(reactSelectStyles)}

    padding: 12px 16px;

    ${colorVariant(isSelected, isDisabled, isFocused, theme)}
    ${backgroundVariant(isSelected, isFocused, theme)}
    ${fontVariant(isSelected, isFocused, theme)}

    ${theme.isAccessibleTheme &&
    isFocused &&
    !isSelected &&
    css`
      ${Name}, ${Text} {
        font-weight: 700;
        color: ${theme.colors.contentInversePrimary} !important;
      }
    `}

    ${!isDisabled &&
    css`
      &:active {
        color: ${theme.colors.contentInversePrimary};
        background-color: ${theme.colors.interactionSecondary};
      }

      ${theme.isAccessibleTheme &&
      css`
        &:hover {
          background-color: ${theme.colors.interactionSecondary};
          color: ${theme.colors.contentInversePrimary};

          ${Name}, ${Text} {
            font-weight: 700;
            color: ${theme.colors.contentInversePrimary} !important;
          }
        }
      `}
    `}

    ${groupLayout &&
    indented &&
    css`
      ${Name} {
        margin-left: 8px;
      }
    `}
  `
);
